'use es6';

import PropTypes from 'prop-types';
export default PropTypes.shape({
  icon: PropTypes.string,
  iconColor: PropTypes.string,
  size: PropTypes.number
});